import './logcabin/style';
import FormStructure from './logcabin/form_structure';

export default FormStructure;